import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchDiscountCodes, deleteDiscountCode } from "../../actions/discountCodes";
import { getAllDiscountCodes } from "../../reducers";
import { MDBCol, MDBContainer, MDBRow, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";

const DiscountCodes = ({ codes, fetchDiscountCodes, deleteDiscountCode }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredCodes, setFilteredCodes] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const codesPerPage = 20;
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        fetchDiscountCodes();
    }, [fetchDiscountCodes]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const result = codes.filter(code =>
            code.code.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredCodes(result);
    }, [searchQuery, codes]);

    const handleDelete = (id) => {
        if (window.confirm("Jeste li sigurni da želite izbrisati ovaj kod?")) {
            deleteDiscountCode(id);
        }
    };

    const indexOfLast = currentPage * codesPerPage;
    const indexOfFirst = indexOfLast - codesPerPage;
    const currentCodes = filteredCodes.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredCodes.length / codesPerPage);

    return (
        <div className="font-tiskani" style={{ paddingTop: "10rem" }}>
            <section className="h-100 h-custom padding">
                <MDBContainer className="container-cart py-5 h-100 color-white padding">
                    <MDBRow className="justify-content-center align-items-center h-100">
                        <MDBCol>
                            <div className="filter-div" style={{ paddingBottom: "1.5rem" }}>
                                <label>Traži kod:</label>
                                <input
                                    type="text"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                <Link to="/admin/discounts/new" className="btn btn-primary" style={{ marginLeft: "1rem" }}>
                                    + Novi kod
                                </Link>
                            </div>

                            <MDBTable responsive>
                                <MDBTableHead>
                                    <tr>
                                        {windowWidth > 700 && <th>ID</th>}
                                        <th>Kod</th>
                                        <th>Popust</th>
                                        <th>Vrijedi</th>
                                        <th>Vrijeme</th>
                                        <th>Akcije</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {currentCodes.map(code => (
                                        <tr key={code.id}>
                                            {windowWidth > 700 && <td>{code.id}</td>}
                                            <td>{code.code}</td>
                                            <td>{(code.discount * 100).toFixed(0)}%</td>
                                            <td>{code.valid ? "Da" : "Ne"}</td>
                                            <td>{code.startDate} – {code.endDate}</td>
                                            <td>
                                                <Link to={`/admin/discounts/${code.id}`} style={{ marginRight: "1rem" }}>
                                                    Uredi
                                                </Link>
                                                <button onClick={() => handleDelete(code.id)} className="btn btn-sm btn-danger">
                                                    Izbriši
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </MDBTableBody>
                            </MDBTable>

                            <div style={{ textAlign: "center", marginTop: "2rem" }}>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <button
                                        key={i}
                                        onClick={() => setCurrentPage(i + 1)}
                                        style={{
                                            margin: '0 5px',
                                            padding: '0.5rem 1rem',
                                            backgroundColor: currentPage === i + 1 ? '#333' : '#fff',
                                            color: currentPage === i + 1 ? '#fff' : '#333',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </section>
        </div>
    );
};

DiscountCodes.propTypes = {
    codes: PropTypes.array.isRequired,
    fetchDiscountCodes: PropTypes.func.isRequired,
    deleteDiscountCode: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    codes: getAllDiscountCodes(state)
});

const mapDispatchToProps = {
    fetchDiscountCodes,
    deleteDiscountCode
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountCodes);
